import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export function DataConnectMultiPoolTableHeaders() {
  return <>
    <tbody>
      <tr>
        <th className={`${poolTableHeadersLine} ${poolTableHeadersSmallWidth}`} data-tb-test-id={'pool-expand-icon-column-header'}/>
        <th className={`${poolTableHeadersLine} ${tableCell300Width}` }>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-name-column-header'}>
            {Messages.dataConnectSiteSettingsPoolColumnName()}
          </span>
        </th>
        <th className={ `${poolTableHeadersLine} ${tableCell200Width}`}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'empty-column-header'}>
          &nbsp;
          </span>
        </th>
        <th className={`${poolTableHeadersLine} ${tableCell200Width}`}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-status-column-header'}>
            {Messages.dataConnectSiteSettingsPoolStatusColumnName()}
          </span>
        </th>
        <th className={poolTableHeadersLine} data-tb-test-id={'pool-actions-column-header'}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-actions-column-header'}>
            {Messages.dataConnectSiteSettingsPoolActionsColumnName()}
          </span>
        </th>
      </tr>
    </tbody>
  </>;
}

export const DataConnectTooltipClass = style({
  height: CommonStyles.Sizes.ExtraSmallIconSize,
  marginLeft: TabStyles.Spacing.SmallSpace,
  verticalAlign: 'text-top',
  outlineStyle: 'none'
});

export const poolTableHeadersLine = style({
  height: CommonStyles.Sizes.DataGridHeaderHeight,
  borderBottomWidth: CommonStyles.Sizes.LineWidth,
  borderBottomColor: CommonStyles.Colors.DividerLineColor,
  borderBottomStyle: 'solid',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  backgroundColor: CommonStyles.Colors.White,
  borderSpacing: 0
});

export const poolTableHeadersSmallWidth = style({
  width: '35px'
});

const tableCell300Width = style({
  width: '300px'
});

const tableCell200Width = style({
  width: '200px'
});


